/**
 * Removes empty values from the given query parameters object.
 * @param queryParams - The query parameters object.
 * @returns The queryParams object without empty values.
 */
const getQueryParamsWithoutEmptyVals = (
  queryParams: Record<string, string | null | undefined>,
) =>
  queryParams
    ? Object.keys(queryParams || {}).reduce((acc, key) => {
        if (queryParams[key] !== null && queryParams[key] !== '') {
          acc[key] = queryParams[key];
        }
        return acc;
      }, {})
    : {};

export default getQueryParamsWithoutEmptyVals;
